import React, { MouseEventHandler, useEffect, useState } from "react";
import cn from "classnames";
import { Link } from "react-router-dom";
import Tag from "src/components/common/Tag";
import IconButton from "../common/IconButton";
import CheckBox from "../common/CheckBox";
import SVG from "src/utils/SVG";
import styled from "styled-components";

interface IComItemProps {
  editMode?: boolean;
  deleteMode?: boolean;
  data?: any;
  profileDetailClick?: MouseEventHandler<HTMLButtonElement> | any;
}

const ComItem = (props: IComItemProps) => {
  const [init, setInit] = useState<any>({
    companyList: [],
  });

  const { companyList } = init;

  useEffect(() => {
    if (props.data) {
      setInit({
        ...init,
        companyList: props.data.data.data,
      });
    }
  }, [props.data]);

  const linkClick = (userId: string) => {
    if (props.profileDetailClick) {
      props.profileDetailClick(userId);
    }
  };

  return (
    <>
      {companyList && companyList.length > 0
        ? companyList.map((item: any, idx: number) => {
            return (
              <ComItemSet className={cn({ "edit-mode": props.editMode || props.deleteMode })} key={idx}>
                <StyledLink onClick={() => linkClick(item.user_id)}>
                  <div>
                    <Tag value={item.company_type} color="level1" />
                  </div>
                  <div>
                    <ManageInfo>
                      <p className="name">
                        {item.name}
                        {item.new && <SVG name="new" width={10} height={16} viewBox="0 0 10 16" />}
                      </p>
                      <p className="tel">{item.phone_number}</p>
                    </ManageInfo>
                    <ManageDetail>{item.address}</ManageDetail>
                  </div>
                </StyledLink>
                <div className="edit-set">
                  {props.deleteMode && (
                    <IconButton btnName="삭제하기" className="delete">
                      <SVG name="trDel" width={20} height={20} viewBox="0 0 20 20" />
                    </IconButton>
                  )}
                  {props.editMode && <CheckBox className="check" id="basic-check1" type="round" />}
                </div>
              </ComItemSet>
            );
          })
        : ""}
    </>
  );
};

const ComItemSet = styled.li<IComItemProps>`
  position: relative;
  &.edit-mode {
    padding-right: 40px;
  }
  .edit-set {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    width: 40px;
    > span {
      top: 20px;
      left: 15px;
    }
    label.round {
      position: relative;
      padding-left: 30px;
      height: 30px;
      > svg {
        left: 50%;
        top: 50%;
        margin-top: -12px;
        margin-left: -12px;
      }
    }
    button.delete {
      position: relative;
      top: 20px;
      left: 15px;
      width: 30px;
      height: 30px;
    }
  }
`;

const StyledLink = styled.div`
  ${({ theme }) => theme.flexBox.flexMixin("row", "space-between", "flex-start")}
  > div:first-child {
    padding-right: 10px;
  }
  > div:last-child {
    flex: 1;
  }
`;

const ManageInfo = styled.div`
  ${({ theme }) => theme.flexBox.flexMixin("row", "space-between", "flex-start")}
  .name {
    flex-basis: 55%;
    color: #000;
    font-size: 16px;
    font-weight: 700;
    > svg {
      position: relative;
      top: -2px;
      margin-left: 5px;
    }
  }
  .tel {
    text-align: right;
    flex-basis: 45%;
    font-family: "Poppins";
    font-weight: 400;
  }
`;

const ManageDetail = styled.div`
  margin-top: 10px;
  ${({ theme }) => theme.textOverflow.multiLine(2)}
`;

export default ComItem;
